import {Component, OnInit } from '@angular/core';
import { AppService } from "./app.service";
import { TranslateService } from './translate/translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{



  constructor(private appService: AppService, private _translate: TranslateService){}

  ngOnInit(){
    this.selectLang('en');

    var userLang = navigator.language;
    if(userLang == 'de'  || userLang == 'en'){
      this.selectLang(userLang);
    }
  }

  selectLang(lang: string) {
    // set current lang;
    this._translate.use(lang);
  }
}
